export const formatDateRange = (start: string, end: string): string => {
	return start === end ? start : `${start} - ${end}`;
};

export const combineDateAndTimeRange = (date: string, time: string): string => {
	return `${date} ${time}`;
};
